// // Centralized API Configuration
// const API_CONFIG = {
//   // Base URLs
//   // BASE_URL: "http://172.23.192.1:4000",
//   BASE_URL: "https://api.experts4u.in",
//   // API_V1: "http://172.23.192.1:4000/api/v1",
//   API_V1: "https://api.experts4u.in/api/v1",
//   // API_V2: "http://172.23.192.1:4000/api/v2",
//   API_V2: "https://api.experts4u.in/api/v2",

//   // Image URLs
//   // IMAGE_URL: "http://172.23.192.1:4000",
//   IMAGE_URL: "https://api.experts4u.in",

//   // Socket URL
//   // SOCKET_URL: "http://172.23.192.1:4000",
//   SOCKET_URL: "https://api.experts4u.in",

//   // Specific endpoints
//   // WALLET_API: "http://172.23.192.1:4000/api/v2/Wallet",
//   WALLET_API: "https://api.experts4u.in/api/v2/Wallet",
//   // NOTIFICATION_API: "http://172.23.192.1:4000/api/v1/Notification",
//   NOTIFICATION_API: "https://api.experts4u.in/api/v1/Notification",
//   // PENALTY_API: "http://172.23.192.1:4000/api/v2/PenltySp",
//   PENALTY_API: "https://api.experts4u.in/api/v2/PenltySp",
//   // CASHBACK_API: "http://172.23.192.1:4000/api/v1/cashback",
//   CASHBACK_API: "https://api.experts4u.in/api/v1/cashback",
//   // LEAD_API: "http://172.23.192.1:4000/api/v2/Leadgeneration",
//   LEAD_API: "https://api.experts4u.in/api/v2/Leadgeneration",
//   // APK_API: "http://172.23.192.1:4000/api/v1/apk",
//   APK_API: "https://api.experts4u.in/api/v1/apk",
//   // APP_VERSION_API: "http://172.23.192.1:4000/api/v2/AppVersion2",
//   APP_VERSION_API: "https://api.experts4u.in/api/v2/AppVersion2",
//   // ID_CARD_API: "http://172.23.192.1:4000/api/v2/IdCard",
//   ID_CARD_API: "https://api.experts4u.in/api/v2/IdCard",
//   // PAGE_API: "http://172.23.192.1:4000/api/v1/page",
//   PAGE_API: "https://api.experts4u.in/api/v1/page",
//   // PAYMENT_API: "http://172.23.192.1:4000/api/v1/paymentgateway",
//   PAYMENT_API: "https://api.experts4u.in/api/v1/paymentgateway",
//   // PLACEHOLDER_API: "http://172.23.192.1:4000/api/v1/placeholderimage",
//   PLACEHOLDER_API: "https://api.experts4u.in/api/v1/placeholderimage",
//   // PACKAGE_API: "http://172.23.192.1:4000/package",
//   PACKAGE_API: "https://api.experts4u.in/package",
//   // MESSAGE_API: "http://172.23.192.1:4000/api/v2/MessageSp",
//   MESSAGE_API: "https://api.experts4u.in/api/v2/MessageSp",
//   // CASHBACK_RULES_API: "http://172.23.192.1:4000/api/v2/Spcashbackrules/spcashbackrule"
//   CASHBACK_RULES_API: "https://api.experts4u.in/api/v2/Spcashbackrules/spcashbackrule"
// };

// export default API_CONFIG;

// Centralized API Configuration
// Base URL is loaded from environment variable REACT_APP_BASE_URL
// Set this in your .env file (see .env.example)
const BASE_URL = "https://api.experts4u.in";
// const BASE_URL = "http://localhost:4000";


const API_CONFIG = {
  // Base URLs
  BASE_URL: BASE_URL,
  API_V1: `${BASE_URL}/api/v1`,
  API_V2: `${BASE_URL}/api/v2`,

  // Image URLs
  IMAGE_URL: BASE_URL,

  // Socket URL
  SOCKET_URL: BASE_URL,

  // Specific endpoints
  WALLET_API: `${BASE_URL}/api/v2/Wallet`,
  NOTIFICATION_API: `${BASE_URL}/api/v1/Notification`,
  PENALTY_API: `${BASE_URL}/api/v2/PenltySp`,
  CASHBACK_API: `${BASE_URL}/api/v1/cashback`,
  LEAD_API: `${BASE_URL}/api/v2/Leadgeneration`,
  APK_API: `${BASE_URL}/api/v1/apk`,
  APP_VERSION_API: `${BASE_URL}/api/v2/AppVersion2`,
  ID_CARD_API: `${BASE_URL}/api/v2/IdCard`,
  PAGE_API: `${BASE_URL}/api/v1/page`,
  PAYMENT_API: `${BASE_URL}/api/v1/paymentgateway`,
  PLACEHOLDER_API: `${BASE_URL}/api/v1/placeholderimage`,
  PACKAGE_API: `${BASE_URL}/package`,
  MESSAGE_API: `${BASE_URL}/api/v2/MessageSp`,
  CASHBACK_RULES_API: `${BASE_URL}/api/v2/Spcashbackrules/spcashbackrule`,

  // Job endpoints
  JOBS_API: `${BASE_URL}/api/v1/jobs`,
  JOB_GET_JOB_FI: `${BASE_URL}/api/v1/jobs/getJobFi`,
  JOB_UPDATE_ASSIGN: `${BASE_URL}/api/v1/jobs/updateAssign`,
  JOB_IMAGE_UPLOAD: `${BASE_URL}/api/v1/JobImageUplode/JobImageUplode`,
  SERVICE_PROVIDER_API: `${BASE_URL}/api/v1/ServiceProvider`,
  APPOINTMENT_SLOT_API: `${BASE_URL}/api/v1/AppoinmentSlot`
};

export default API_CONFIG;
